import { Navlink } from '../core/models/Navlink';
import { MaintenanceRequestPage } from '../pages/maintenance-request-page/maintenance-request-page';

export const LocalStorageToken = 'token';

// page params
export const pageNumberParam = 'pageNumber';
export const pageSizeParam = 'pageSize';
export const orderByParam = 'orderBy';
export const searchTermParam = 'searchTerm';

export const uploadPath = '/uploads';

export const projectsPath = '/projects';
export const grandBlockPath = '/grand-blocks';
export const blockPath = '/blocks';
export const sectionPath = '/sections';
export const projectActivityPath = '/project-activities';
export const reportPath = '/report';
export const timelineReportPath = '/report/timeline';
export const milestoneReportPath = '/report/milestones';
export const manhoursPath = '/manhours/report';
export const manhoursuploadPath = '/manhours/upload';

export const HomePageLink: Navlink = {
  title: 'Home',
  path: '/',
};
